import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { SButton, SIcon } from '@strana-artw/ui-kit';
export default {
  name: 'ModalWrapper',
  components: {
    SButton: SButton,
    SIcon: SIcon
  },
  props: {
    visible: Boolean,
    closeColor: {
      type: String,
      default: 'white'
    },
    closeSize: {
      type: String,
      default: 'default'
    },
    closeBordered: {
      type: Boolean,
      default: true
    },
    infraMap: {
      type: Boolean,
      default: false
    },
    moved: Boolean,
    stories: Boolean,
    genplan: Boolean,
    parking: Boolean,
    repair: Boolean,
    lot: Boolean,
    businessPage: Boolean,
    mortgageCalc: Boolean
  },
  computed: {
    closeButtonClasses: function closeButtonClasses() {
      return [this.$style.close, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, this.$style._moved, this.moved), this.$style._stories, this.stories), this.$style._genplan, this.genplan), this.$style._parking, this.parking), this.$style._repair, this.repair), this.$style._inframap, this.infraMap), this.$style._lot, this.lot), this.$style._mortgageCalc, this.mortgageCalc), this.$style._planoplan, this.planoplan)];
    }
  }
};